// @ts-strict-ignore
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { LMModel } from '@form/model';
import {
  LMBusyIndicatorService,
  LMContextService,
  LMLoggerService,
  LMOverlayService
} from '@services/index';
import { LMFormPagingService } from '@form/services/lm-form-paging.service';
import { LMFormContentBase } from './lm-form.model';
import { LMFormContentCompositeComponent } from './lm-form-content-composite.component';
import { LMFormContentFormComponent } from './lm-form-content-form.component';
import { LMFormContentStepprocessComponent } from './lm-form-content-stepprocess.component';
import { LMFormState } from '@states/models/lm-form-state.model';
import { LMFormPersonalization } from '@states/models/lm-form-personalization.model';
import { LMFormContentManualRepresentationComponent } from './lm-form-content-manual-representation.component';
import { LMFormContentMatrixComponent } from './lm-form-content-matrix.component';
import { LMFormSpecUtilService, LMStepPanelEvent } from './services';
import { Observable } from 'rxjs';
import { LMPanelTransactionEvent } from '@form/services/lm-form-panel.service';
import { LMFormContentSearchComponent } from './lm-form-content-search.component';
import { LMInvalidFieldEvent } from '@app/components';
import { over } from 'lodash-es';

// todo shouldn't this be a in a typedef somewhere? Or perhaps for enums we need to import them from somewhere.
enum LMFormType {
  SEARCH = 0,
  STANDARD,
  COMPOSITE,
  STEP_PROCESS_OR_WIZARD,
  INSTANCE_COUNT_CHART,
  MANUAL_REPRESENTATION,
  MENU_LAYOUT,
  MATRIX
}

@Component({
  selector:    'lm-form-content',
  standalone: false,
  templateUrl: './lm-form-content.component.html',
  styleUrls:   [ 'lm-form-content.component.scss' ],
  providers:   [ LMFormPagingService ]
  })
export class LMFormContentComponent implements OnInit, AfterViewInit, LMFormContentBase {

  @ViewChild('LMManualRepresentation') formManRepComponent: LMFormContentManualRepresentationComponent;
  @ViewChild('LMFormStandardComponent') formStandardComponent: LMFormContentFormComponent;
  @ViewChild('LMStepProcessComponent') stepProcessComponent: LMFormContentStepprocessComponent;
  @ViewChild('LMFormSearchComponent') searchFormComponent: LMFormContentSearchComponent;
  @ViewChild('LMComposite') compositeComponent: LMFormContentCompositeComponent;
  @ViewChild('LMMatrix') formMatrixComponent: LMFormContentMatrixComponent;

  @Input() formUrlInfo: LMFormUrlInfo = null;
  @Input() formSpec: LMFormSpec = null;
  @Input() formOptions: LMFormOptions = null;
  @Input() specFields: LMSpecFields;
  @Input() layout: LMFormLayout;
  @Input() model: LMModel;
  @Input() placeHolder: ViewContainerRef;
  @Input() formState: LMFormState;
  @Input() formPersonalization: LMFormPersonalization;
  @Input() fromDataView: LMDataView;
  @Input() parentIsModal: boolean;
  @Input() instanceId: string;
  @Input() inFormOverlay = false;
  @Input() listUrlInfo: LMListUrlInfo;

  @Output() contentModified = new EventEmitter<any>();
  @Output() contentLoadEvent = new EventEmitter<number>();
  @Output() startComponentTrackEvent = new EventEmitter<any>();
  @Output() customizeButtonClicked = new EventEmitter<LMFilterEvent>();
  @Output() searchButtonClicked = new EventEmitter<LMFilterEvent>();
  @Output() clearSearchButtonClicked = new EventEmitter<LMFilterEvent>();
  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();
  @Output() stepPanelEvent: EventEmitter<LMStepPanelEvent> = new EventEmitter<LMStepPanelEvent>();
  @Output() updateToolbarStateEvent = new EventEmitter<any>();
  @Output() sendContextMessageEvent = new EventEmitter<any>();
  @Output() sendShortcutMessage = new EventEmitter<any>();
  @Output() specialActionsToolbarButtonEvent = new EventEmitter<LMSpecialActionToolbarButtonEvent>();
  @Output() panelTransactionEvent = new EventEmitter<LMPanelTransactionEvent>();
  @Output() drillAroundEvent = new EventEmitter<LMDrillAroundEvent>();
  @Output() matrixActionEvent = new EventEmitter<LMMatrixActionEvent>();
  @Output() contentRendered = new EventEmitter<void>();

  // private verticalTabs = false;
  // private contextForm: LMContextForm;
  // private panels: Array<LandmarkPanel> = [];
  private routeReuseTemplateLoad = 0;
  public subType: LMFormType;
  layoutSubType;

  constructor(
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmFormSpecUtilService: LMFormSpecUtilService,
    private lmContextService: LMContextService,
    private lmLoggerService: LMLoggerService,
    private lmOverlayService: LMOverlayService
  ) {
    this.layoutSubType = LMFormType;
  }

  ngOnInit() {
    this.lmLoggerService.log([ this, this.instanceId, 'ngOnInit()' ]);
    this.initialize();
  }

  ngAfterViewInit() {
    // this.lmLoggerService.log([this, this.instanceId, 'ngAfterViewInit()']);
    //
    // This marks the end of form intialization. Remove the busy indicator started in lm-form.component constructor or ngOnInit
    if (this.lmContextService.useListFormOverlay() && this.inFormOverlay) {
      this.lmOverlayService.busyIndicator(false);
    } else {
      this.lmBusyIndicatorService.hideBusyIndicator();
    }

    this.contentRendered.emit();
    this.endLogging();
  }

  public endLogging(): number {
    let loadTime = 0;
    if (this.isActionForm) {
      loadTime = this.lmLoggerService.timeEnd('TotalActionForm', [ this, 'ngAfterViewInit()', 'end' ]);
    } else {
      loadTime = this.lmLoggerService.timeEnd(`Total-Form-${this.instanceId}`, [ this, 'ngAfterViewInit()', 'end' ]);
    }
    this.sendPageAnalytics(loadTime);
    this.setRouteReuseTemplateLoadTime(loadTime)
    return loadTime;
  }

  public getRouteReuseTemplateLoadTime(): number {
    return this.routeReuseTemplateLoad;
  }

  public setRouteReuseTemplateLoadTime(loadTime: number) {
    if (this.routeReuseTemplateLoad <= 0) {;
      this.routeReuseTemplateLoad = loadTime
    }
  }

  private initialize() {
    // if (this.formOptions.compositeFormOptions) {
    //   this.verticalTabs = this.formOptions.compositeFormOptions.verticalTabs;
    //   this.contextForm = this.formOptions.compositeFormOptions.contextForm;
    //   this.panels = this.formOptions.compositeFormOptions.panels;
    // }

    if (this.isSearchForm) {
      this.subType = LMFormType.SEARCH;

    } else if (this.isStandardForm && !this.isActionFormWithSections) {
      this.subType = LMFormType.STANDARD;

    } else if (this.isCompositeForm || this.isActionFormWithSections) {
      this.subType = LMFormType.COMPOSITE;

    } else if (this.isStepProcessForm || this.formSpec.busFormSpec.isWizard) {
      this.subType = LMFormType.STEP_PROCESS_OR_WIZARD;

    } else if (this.isInstanceCountChartForm) {
      this.subType = LMFormType.INSTANCE_COUNT_CHART;

    } else if (this.isManualRepresentationForm) {
      this.subType = LMFormType.MANUAL_REPRESENTATION;

    } else if (this.isMenuLayoutForm) {
      this.subType = LMFormType.MENU_LAYOUT;

    } else if (this.isMatrixForm) {
      this.subType = LMFormType.MATRIX;

    }

    if (this.lmContextService.inMingleOverlay()) {
      this.parentIsModal = true;
    }
  }

  private sendFormData(): boolean {
    return (!this.isActionForm &&
      !this.isChangePasswordForm &&
      !this.isBusinessTaskForm &&
      !this.isSearchForm &&
      !this.isPageContextForm &&
      !this.isResponseRequired &&
      !this.isCompactForm &&
      !this.formOptions.isDashBoardContent &&
      !this.formSpec.dependentForm);
  }

  private sendPageAnalytics(loadTime: number): void {
    // safety
    if (!loadTime) {
      return;
    }

    if (this.sendFormData()) {
      this.contentLoadEvent.emit(loadTime);
    } else if (this.isActionForm) {
      this.contentLoadEvent.emit(loadTime);
    } else {
      this.startComponentTrackEvent.emit(loadTime);
    }
  }

  get canShowReportFieldPickerDrawer() {
    return (this.isStandardForm || this.isCompositeForm)
      && !(this.isActionForm
      || this.isBusinessTaskForm
      || this.isSearchForm
      || this.isPageContextForm
      || this.isResponseRequired
      || this.isMenuLayoutForm
      || this.isCompactForm
      || this.isSubForm
      || this.isChangePasswordForm
      // || this.isMatrixForm   // Not needed, if matrix or instance chart form is not a standard or composite
      // || this.isInstanceCountChartForm
      || this.lmFormSpecUtilService.isDetailFieldsForm()
      || this.lmContextService.inMingleOverlay()
      || this.lmContextService.inMingleInbox()
      || this.lmContextService.inMingleWidget());
  }

  get isPageContextForm(): boolean {
    return this.lmFormSpecUtilService.isPageContextForm(this.formSpec);
  }

  get isSearchForm(): boolean {
    return this.lmFormSpecUtilService.isSearchForm(this.formSpec);
  }

  get isStandardForm(): boolean {
    return (this.lmFormSpecUtilService.isStandardForm(this.formSpec));
  //    && this.lmFormSpecUtilService.formName(this.formSpec) !== 'ManualRepresentation');
  }

  get isContextForm(): boolean {
    return (this.lmFormSpecUtilService.isContextForm(this.formSpec));
  }

  get isStepProcessForm(): boolean {
    return this.lmFormSpecUtilService.isStepProcessForm(this.formSpec);
  }

  get isMenuLayoutForm(): boolean {
    return this.lmFormSpecUtilService.isMenuLayoutForm(this.formSpec);
  }

  get isMatrixForm(): boolean {
    return this.lmFormSpecUtilService.isMatrixForm(this.formSpec);
  }

  get isCompositeForm(): boolean {
    return this.lmFormSpecUtilService.isCompositeForm(this.formSpec);
  }

  get isInstanceCountChartForm(): boolean {
    return this.lmFormSpecUtilService.isInstanceCountChartForm(this.formSpec);
  }

  get isManualRepresentationForm(): boolean {
    return false;

  //  return this.formSpec.busFormSpec.name === 'ManualRepresentation';
  }

  get isActionForm(): boolean {
    return this.lmFormSpecUtilService.isActionForm(this.formSpec);
  }

  get isActionFormWithSections() {
    return this.isActionForm && this.formSpec.busFormSpec.panels;
  }

  get isResponseRequired(): boolean {
    return this.lmFormSpecUtilService.isResponseRequired(this.formSpec);
  }

  get isCompactForm(): boolean {
    return this.lmFormSpecUtilService.isCompactForm(this.formSpec);
  }
  get isSubForm(): boolean {
    return this.lmFormSpecUtilService.isSubForm(this.formSpec);
  }
  get isChangePasswordForm(): boolean {
    return this.lmFormSpecUtilService.isChangePasswordForm(this.formSpec);
  }

  get isBusinessTaskForm(): boolean {
    return this.lmFormSpecUtilService.isBusinessTask(this.formSpec);
  }

  public onContentModified(event: any) {
    this.contentModified.emit(event);
  }

  public onCustomizeClicked(event: LMFilterEvent) {
    this.customizeButtonClicked.emit(event);
  }

  public onSearchClicked(event: LMFilterEvent) {
    this.searchButtonClicked.emit(event);
  }

  public onClearSearchClicked(event: LMFilterEvent) {
    this.clearSearchButtonClicked.emit(event);
  }

  public onFieldEvent(event) {
    this.fieldEvent.emit(event);
  }

  public onRunMatrixActionEvent(event) {
    this.matrixActionEvent.emit(event);
  }

  public onUpdateToolbarStateEvent(event: any) {
    this.updateToolbarStateEvent.emit();
  }

  public onStepPanelEvent(event) {
    this.stepPanelEvent.emit(event);
  }

  public onSendContextMessageEvent(event: any) {
    this.sendContextMessageEvent.emit(event);
  }

  public onSendShortcutMessage(event: any) {
    this.sendShortcutMessage.emit(event);
  }

  public onSpecialActionToolbarButtonEvent(event: LMSpecialActionToolbarButtonEvent) {
    this.specialActionsToolbarButtonEvent.emit(event);
  }

  public onPanelTransactionEvent(event: LMPanelTransactionEvent): void {
    this.panelTransactionEvent.emit(event);
  }

  onDrillAroundEvent(event: LMDrillAroundEvent) {
    this.drillAroundEvent.emit(event);
  }

  // TODO implement a common interface
  // isModified()
  // runSaveAction()
  // saveComponentState()
  isModified(): boolean {
    if (this.isStandardForm) {
      return this.formStandardComponent.isModified();
    } else if (this.isCompositeForm) {
      return this.compositeComponent.isModified();
    } else if (this.isStepProcessForm) {
      return this.stepProcessComponent.isModified();
    } else if (this.isManualRepresentationForm) {
      return this.formManRepComponent.isModified();
    } else if (this.isMatrixForm) {
      return this.formMatrixComponent.isModified();
    } else {
      return false;
    }
  }

  isRelatedModified(): boolean {

    if (this.isCompositeForm) {
      return this.compositeComponent.isRelatedModified();
    } else if (this.isStepProcessForm) {
      return this.stepProcessComponent.isRelatedModified();
    } else {
      return false;
    }
  }

  canActivatePanel(fieldId): boolean {
    if (this.isCompositeForm) {
      return this.compositeComponent.canActivatePanel(fieldId);
    }
    return false;
  }

  runMatrixToggleDetail(showDetail: boolean) {
    if (this.isMatrixForm) {
      return this.formMatrixComponent.runMatrixToggleDetail(showDetail);
    }
  }

  runRefresh() {
    if (this.isStandardForm) {
      return this.formStandardComponent.runRefresh();
    } else if (this.isCompositeForm) {
      return this.compositeComponent.runRefresh();
    } else if (this.isStepProcessForm) {
      return this.stepProcessComponent.runRefresh();
    } else if (this.isManualRepresentationForm) {
      return this.formManRepComponent.runRefresh();
    } else if (this.isMatrixForm) {
      return this.formMatrixComponent.runRefresh();
    }
  }

  runSaveAction(): Observable<boolean> {
    if (this.isStandardForm) {
      return this.formStandardComponent.runSaveAction();
    } else if (this.isCompositeForm) {
      return this.compositeComponent.runSaveAction();
    } else if (this.isStepProcessForm) {
      return this.stepProcessComponent.runSaveAction();
    } else if (this.isManualRepresentationForm) {
      return this.formManRepComponent.runSave();
    } else if (this.isMatrixForm) {
      return this.formMatrixComponent.runSaveAction();
    }
  }

  saveComponentState() {
    if (this.formStandardComponent) {
      this.formStandardComponent.saveComponentState();
    }
    if (this.compositeComponent) {
      this.compositeComponent.saveComponentState();
    }

    if (this.stepProcessComponent) {
      this.stepProcessComponent.saveComponentState();
    }
  }

  clearComponentState() {
    if (this.formStandardComponent) {
      this.formStandardComponent.clearComponentState();
    }
    if (this.compositeComponent) {
      this.compositeComponent.clearComponentState();
    }

    if (this.stepProcessComponent) {
      this.stepProcessComponent.clearComponentState();
    }
  }

  handleBlockingErrorField(event: LMInvalidFieldEvent) {
    if (this.isStandardForm) {
      return this.formStandardComponent.handleBlockingErrorField(event);
    } else if (this.isCompositeForm) {
      return this.compositeComponent.handleBlockingErrorField(event);
    } else if (this.isStepProcessForm) {
      return this.stepProcessComponent.handleBlockingErrorField(event);
    } else if (this.isManualRepresentationForm) {
      return this.formManRepComponent.handleBlockingErrorField(event);
    } else if (this.isMatrixForm) {
      return this.formMatrixComponent.handleBlockingErrorField(event);
    }
  }

  protected readonly over = over;
}
